import React from 'react'
import { Text, View, Card, useStyles } from '@ion-ui/core'
import { useMediaQuery } from 'react-responsive'
import StepsCard from '../Cards/StepsCard'
import { Styles } from './styles'

const items = [{
  index: 1,
  title: 'Simula tu crédito',
  description: 'Conoce en un minuto cuánto dinero puedes obtener con nosotros en nuestro simulador.'
},
{
  index: 2,
  title: 'Completa un sencillo formulario',
  description: '¡Y en tan sólo 5 minutos podrás recibir una oferta de crédito especialmente para ti!'
},
{
  index: 3,
  title: 'Obtén oferta personalizada',
  description: 'Recibe en tu correo la mejor propuesta de crédito para ti, no la vas a querer rechazar.'
},
{
  index: 4,
  title: 'Haz tu sueño realidad',
  description: 'Una vez que aceptes nuestra oferta, recibe los recursos en menos de 5 días* y úsalos para cumplir tus sueños.'
}]

const GetYourCredit = () => {
  const styles = useStyles(Styles)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <View variant='section' css={styles.container}>
      <View css={styles.subContainer}>
        <Text variant={isMobile ? 'h4' : 'h2'} css={styles.title}>
          Sólo 4 pasos<br />para obtener<br />tu crédito
        </Text>
        <Card variant='steps' css={styles.card}>
          {items.map((item, i) =>
            <StepsCard
              key={`${item} ${i}`}
              {...item}
            />
          )}
        </Card>
      </View>
    </View>
  )
}

export default GetYourCredit
